import { ChecksForm } from "../../components";

const CheckInd = () => {
  return <ChecksForm layout="checkin" />;
};

export default CheckInd;
